/* eslint-disable react/jsx-no-target-blank */
import {useIntl} from 'react-intl'
import {AsideMenuItemWithSub} from './AsideMenuItemWithSub'
import {AsideMenuItem} from './AsideMenuItem'
import {useAuth} from '../../../../app/modules/auth'

export function AsideMenuMain() {
  const intl = useIntl()
  const {currentUser} = useAuth()

  return false ? (
    <>
      <AsideMenuItem
        to='/enabler'
        icon='/media/icons/duotune/finance/fin010.svg'
        title='Transaction'
        fontIcon='bi-app-indicator'
      />
    </>
  ) : (
    <>
      <AsideMenuItem
        to='/dashboard'
        icon='/media/icons/duotune/art/art002.svg'
        title={intl.formatMessage({id: 'MENU.DASHBOARD'})}
        fontIcon='bi-app-indicator'
      />
      <AsideMenuItemWithSub
        to='/member-management'
        title='Member Management'
        icon='/media/icons/duotune/communication/com006.svg'
        fontIcon='bi-person'
      >
        <AsideMenuItem to='/member-management/member' title='Member' hasBullet={true} />
        <AsideMenuItem
          to='/member-management/customer-state'
          title='Customer State'
          hasBullet={true}
        />
      </AsideMenuItemWithSub>
      <AsideMenuItemWithSub
        to='/self-care-plan'
        title='Self Care Plan'
        icon='/media/icons/duotune/medicine/med001.svg'
        fontIcon='bi-person'
      >
        <AsideMenuItem to='/self-care-plan/persona' title='Persona' hasBullet={true} />
        <AsideMenuItem to='/self-care-plan/self-care' title='Self-Care' hasBullet={true} />
        <AsideMenuItem to='/self-care-plan/testimoni' title='Testimoni' hasBullet={true} />
      </AsideMenuItemWithSub>
      <AsideMenuItemWithSub
        to='/loyalty-point'
        title='Loyalty Point'
        icon='/media/icons/duotune/finance/fin010.svg'
        fontIcon='bi-person'
      >
        <AsideMenuItem
          to='/loyalty-point/product'
          title='Product & Point Mapping'
          hasBullet={true}
        />
        <AsideMenuItem
          to='/loyalty-point/rewards-catalog'
          title='Rewards Catalog'
          hasBullet={true}
        />
        <AsideMenuItem to='/loyalty-point/campaign' title='Campaign' hasBullet={true} />
        <AsideMenuItem
          to='/loyalty-point/transaction-management'
          title='Transaction Management'
          hasBullet={true}
        />
        <AsideMenuItem
          to='/loyalty-point/redemption-management'
          title='Redemption Management'
          hasBullet={true}
        />
        <AsideMenuItem to='/loyalty-point/user-point' title='User Points' hasBullet={true} />
      </AsideMenuItemWithSub>
      {/* <AsideMenuItem
        to='/enabler'
        icon='/media/icons/duotune/general/gen054.svg'
        title='Enabler'
        fontIcon='bi-layers'
      /> */}
      <AsideMenuItemWithSub
        to='/configuration'
        icon='/media/icons/duotune/general/gen019.svg'
        title='Configuration'
        fontIcon='bi-layers'
      >
        <AsideMenuItem to='/configuration/point' title='Point Configuration' hasBullet={true} />
        <AsideMenuItem
          to='/configuration/department'
          title='Department Configuration'
          hasBullet={true}
        />
      </AsideMenuItemWithSub>
    </>
  )
}
